import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'mibi-activate-view',
    templateUrl: './activate-view.component.html'
})
export class ActivateViewComponent {

}
